import React from "react"
import { NavItemWrapper } from "./MainNavigation"
import { useIntl } from "react-intl"
import { Paths } from "#/utils/Paths"

export function FaqsNavItem({ onClick }: { onClick: () => void }): JSX.Element {
  const intl = useIntl()

  const handleClick = () => {
    window.open(Paths.FAQS, "_blank")
    onClick()
  }

  return (
    <NavItemWrapper
      link={Paths.FAQS}
      button
      onClick={handleClick}
      text={intl.formatMessage({
        defaultMessage: "FAQs",
        description:
          "Navigation bar label to route users to the Frequently Asked Questions page. Please do not translate the letters F-A-Q-S literally. Use the standard shorthand or acronym for 'Frequently Asked Questions' for the locale (e.g. the equivalent abbreviation that is used)."
      })}
    />
  )
}
